import { Card, ListItem, ListItemText, SxProps, Theme, Typography } from '@/components'
import { BaseProps } from '@/components/types'
import { CSSProperties } from 'react'

function CardListItem ( props: CardListItemProps ) {
    const {
        style, primaryText, secondaryText, secondary,
        marginBottom = '8px', marginTop = '8px',
        leftContents, rightContents,
        ...rest
    } = props
    const textStyle: CSSProperties = {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        outline: 'none',
        whiteSpace: 'nowrap',
    }
    return (
        <Card sx={ { marginTop, marginBottom, alignItems: 'center', display: 'flex' , ...style } }>
            <div className="flex" style={ { marginTop, marginBottom } }>
                <ListItem
                    { ...rest }
                    sx={ {
                        overflow: 'hidden',
                        outline: 'none',
                    } }
                >
                    { leftContents && leftContents }
                    <ListItemText
                        className="w100p"
                        primary={
                            <span className="flex">
                                <Typography
                                    sx={ textStyle }
                                    component="span"
                                    variant="body1"
                                    color="text.primary"
                                >
                                    { primaryText }
                                </Typography>
                            </span>
                        }
                        secondary={ secondary || <span style={ textStyle }>{ }</span> }
                    />
                </ListItem>
                {
                    rightContents &&
                    <div style={ { marginLeft: 'auto', padding: '8px' } }>
                        { rightContents }
                    </div>
                }
            </div>
        </Card>
    )
}

export default CardListItem

export interface CardListItemProps extends BaseProps {
    primaryText: string | JSX.Element
    secondaryText?: string | JSX.Element
    secondary?: string | JSX.Element
    leftContents?: JSX.Element
    rightContents?: JSX.Element
    marginTop?: string | number
    marginBottom?: string | number
}